import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Link, useNavigate } from 'react-router-dom'
import Hands from '../Assets/Assests/Group-Hands.png'

const GiveBack = () => {
  return (
    <>
      <Header />

      <div className='min-h-screen' style={{ backgroundColor: '#fff' }}>
        <header
          id='home'
          className='container-fluid pt-4 pt-md-5 pt-sm-5'
          style={{ background: '#EAFBFF' }}
        >
          <div className='container-fluid px-0'>
            <div
              className='row align-items-center'
              style={{
                minHeight: '40vh',
                marginTop: '30px',
              }}
            >
              <div className='col-12 col-lg-6 px-3 px-md-4 px-lg-5 mt-5'>
                <h1
                  className='mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    fontFamily: 'Inter',
                    fontWeight: '700',
                    fontSize: 'clamp(1.8rem, 6vw, 3.4rem)',
                    color: '#1F3A6A',
                  }}
                >
                  Give Back –{' '}
                  <span
                    style={{
                      fontFamily: 'Inter',
                      fontWeight: '700',
                      fontSize: 'clamp(1.8rem, 6vw, 3.4rem)',
                      color: '#889E7E',
                    }}
                  >
                    Building Brighter Futures Together
                  </span>
                </h1>
              </div>

              {/* Image aligned right, no padding */}
              <div className='col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end pe-0'>
                <img
                  src={Hands}
                  alt='Hands'
                  style={{
                    maxWidth: '100%',
                    width: 'clamp(250px, 60vw, 500px)',
                    height: 'auto',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </div>
            </div>
          </div>
        </header>
        <div className='container mt-4 mt-md-5 py-3 py-md-4'>
          <h2
            className='mb-3 text-center text-lg-start'
            style={{
              color: '#2D5272',
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            }}
          >
            Empowering Youth Through Corporate Support
          </h2>
          <p
            className='mb-4 mb-md-5 text-center text-lg-start'
            style={{
              fontFamily: 'Inter',
              fontWeight: '200',
              fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
              color: '#666666',
            }}
          >
            In today’s dynamic business environment, corporate support for
            educational initiatives is more vital than ever. Enterprises have
            the power to transform lives by equipping underprivileged youth with
            practical skills for success. Tesla Bird is dedicated to ensuring
            that every membership translates into a comprehensive skilled
            program for a disadvantaged child.
          </p>
          <h2
            className='mb-3 text-center text-lg-start'
            style={{
              color: '#2D5272',
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            }}
          >
            Bridging the Skill Gap for a Better Future
          </h2>
          <p
            className='mb-4 mb-md-5 text-center text-lg-start'
            style={{
              fontFamily: 'Inter',
              fontWeight: '200',
              fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
              color: '#666666',
            }}
          >
            These carefully designed programs address the critical skill gaps
            needed in today’s competitive job market. By acquiring these
            essential abilities, young learners are better positioned to secure
            meaningful employment. Corporate investment in education catalyzes
            personal growth and strengthens the fabric of communities. Quality
            learning opportunities help break the cycle of poverty and lay the
            foundation for lasting economic stability. Such initiatives open
            doors to career paths that might otherwise remain out of reach. A
            well-educated workforce drives innovation and supports the overall
            health of the economy. By backing these programs, businesses
            contribute directly to eradicating poverty and fostering social
            equality.
          </p>
          <h2
            className='mb-3 text-center text-lg-start'
            style={{
              color: '#2D5272',
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            }}
          >
            Creating Equal Opportunities and Driving Change
          </h2>
          <p
            className='mb-4 mb-md-5 text-center text-lg-start'
            style={{
              fontFamily: 'Inter',
              fontWeight: '200',
              fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
              color: '#666666',
            }}
          >
            This support ensures that every child, regardless of background, is
            given a fair chance to succeed. Collaborations between companies and
            educational providers help level the playing field in society. A
            steadfast commitment to education serves as a powerful force for
            social transformation and upliftment. Empowered individuals evolve
            into proactive contributors, sparking progress and positive change.
            Tesla Bird’s focus on quality education for the underprivileged
            demonstrates its dedication to societal advancement.
          </p>
          <h2
            className='mb-3 text-center text-lg-start'
            style={{
              color: '#2D5272',
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            }}
          >
            Building Confidence and Securing Careers
          </h2>
          <p
            className='mb-4 mb-md-5 text-center text-lg-start'
            style={{
              fontFamily: 'Inter',
              fontWeight: '200',
              fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
              color: '#666666',
            }}
          >
            Each skilled program provided is a pivotal step toward closing the
            opportunity gap. This initiative not only nurtures emerging talent
            but also builds lasting confidence in young minds. With the proper
            education, these future professionals are more likely to secure
            stable, rewarding careers. Investing in education today lays the
            groundwork for a future characterized by equality and shared
            prosperity. Such efforts ultimately create a society where every
            individual has the opportunity to thrive and contribute
            meaningfully.
          </p>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default GiveBack

// import Header from './Header'
// import Footer from './Footer'
// import Hands from '../Assets/Assests/Group-Hands.png'

// const GiveBack = () => {
//   return (
//     <>
//       <Header />

//       <div className='min-vh-100' style={{ backgroundColor: '#fff' }}>
//         {/* Hero Section */}
//         <header
//           id='home'
//           className='container-fluid pt-4 pt-md-5'
//           style={{ background: '#EAFBFF' }}
//         >
//           <div className='container-fluid px-0'>
//             <div
//               className='row align-items-center g-0'
//               style={{
//                 minHeight: '40vh',
//                 marginTop: '30px',
//               }}
//             >
//               <div className='col-12 col-lg-6 order-2 order-lg-1 px-3 px-md-4 px-lg-5'>
//                 <h1
//                   className='mb-3 mb-md-4 text-center text-lg-start'
//                   style={{
//                     fontFamily: 'Inter',
//                     fontWeight: '700',
//                     fontSize: 'clamp(1.8rem, 6vw, 3.4rem)',
//                     color: '#1F3A6A',
//                     lineHeight: '1.2',
//                   }}
//                 >
//                   Give Back –{' '}
//                   <span
//                     className='d-block d-lg-inline'
//                     style={{
//                       fontFamily: 'Inter',
//                       fontWeight: '700',
//                       fontSize: 'clamp(1.8rem, 6vw, 3.4rem)',
//                       color: '#889E7E',
//                     }}
//                   >
//                     Building Brighter Futures Together
//                   </span>
//                 </h1>
//               </div>

//               {/* Image Section */}
//               <div className='col-12 col-lg-6 order-1 order-lg-2 d-flex justify-content-center justify-content-lg-end pe-0'>
//                 <img
//                   src={Hands || '/placeholder.svg'}
//                   alt='Hands'
//                   className='img-fluid'
//                   style={{
//                     maxWidth: '100%',
//                     width: 'clamp(250px, 60vw, 500px)',
//                     height: 'auto',
//                     objectFit: 'cover',
//                     display: 'block',
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </header>

//         {/* Content Section */}
//         <div className='container mt-4 mt-md-5 py-3 py-md-4'>
//           <div className='row'>
//             <div className='col-12 col-lg-11 col-xl-10'>
//               {/* Section 1 */}
//               <h2
//                 className='mb-3 text-center text-lg-start'
//                 style={{
//                   color: '#2D5272',
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                 }}
//               >
//                 Empowering Youth Through Corporate Support
//               </h2>
//               <p
//                 className='mb-4 mb-md-5 text-center text-lg-start'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '300',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 In today's dynamic business environment, corporate support for
//                 educational initiatives is more vital than ever. Enterprises
//                 have the power to transform lives by equipping underprivileged
//                 youth with practical skills for success. Tesla Bird is dedicated
//                 to ensuring that every membership translates into a
//                 comprehensive skilled program for a disadvantaged child.
//               </p>

//               {/* Section 2 */}
//               <h2
//                 className='mb-3 text-center text-lg-start'
//                 style={{
//                   color: '#2D5272',
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                 }}
//               >
//                 Bridging the Skill Gap for a Better Future
//               </h2>
//               <p
//                 className='mb-4 mb-md-5 text-center text-lg-start'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '300',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 These carefully designed programs address the critical skill
//                 gaps needed in today's competitive job market. By acquiring
//                 these essential abilities, young learners are better positioned
//                 to secure meaningful employment. Corporate investment in
//                 education catalyzes personal growth and strengthens the fabric
//                 of communities. Quality learning opportunities help break the
//                 cycle of poverty and lay the foundation for lasting economic
//                 stability. Such initiatives open doors to career paths that
//                 might otherwise remain out of reach. A well-educated workforce
//                 drives innovation and supports the overall health of the
//                 economy. By backing these programs, businesses contribute
//                 directly to eradicating poverty and fostering social equality.
//               </p>

//               {/* Section 3 */}
//               <h2
//                 className='mb-3 text-center text-lg-start'
//                 style={{
//                   color: '#2D5272',
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                 }}
//               >
//                 Creating Equal Opportunities and Driving Change
//               </h2>
//               <p
//                 className='mb-4 mb-md-5 text-center text-lg-start'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '300',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 This support ensures that every child, regardless of background,
//                 is given a fair chance to succeed. Collaborations between
//                 companies and educational providers help level the playing field
//                 in society. A steadfast commitment to education serves as a
//                 powerful force for social transformation and upliftment.
//                 Empowered individuals evolve into proactive contributors,
//                 sparking progress and positive change. Tesla Bird's focus on
//                 quality education for the underprivileged demonstrates its
//                 dedication to societal advancement.
//               </p>

//               {/* Section 4 */}
//               <h2
//                 className='mb-3 text-center text-lg-start'
//                 style={{
//                   color: '#2D5272',
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                 }}
//               >
//                 Building Confidence and Securing Careers
//               </h2>
//               <p
//                 className='mb-4 mb-md-5 text-center text-lg-start'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '300',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 Each skilled program provided is a pivotal step toward closing
//                 the opportunity gap. This initiative not only nurtures emerging
//                 talent but also builds lasting confidence in young minds. With
//                 the proper education, these future professionals are more likely
//                 to secure stable, rewarding careers. Investing in education
//                 today lays the groundwork for a future characterized by equality
//                 and shared prosperity. Such efforts ultimately create a society
//                 where every individual has the opportunity to thrive and
//                 contribute meaningfully.
//               </p>
//             </div>
//           </div>
//         </div>

//         <Footer />
//       </div>
//     </>
//   )
// }

// export default GiveBack
